// // Main.js or Main.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import History from "../pages/History/History";
import HomePage from "../pages/HomePage/HomePage";
import { authProvider } from "../../authProvider";
import AzureAD from "react-aad-msal";
import RequestDetailsPage from "../pages/RequestDetailsPage/RequestDetailsPage";

const Main = () => {
  return (
    <div>
      <main>
        <AzureAD provider={authProvider} forceLogin={true}>
          <Routes>
            <Route path="/history" element={<History />} />
            <Route path="/history/:id" element={<RequestDetailsPage />} />
            <Route path="/request" element={<HomePage />} />
            <Route exact path="/" element={<Navigate to="/request" />} />
          </Routes>
        </AzureAD>
      </main>
    </div>
  );
};

export default Main;
